export function mainNav() {
    const mainWrap = this._document.querySelector("html");
    const menuBtn = this._document.querySelector(".menu-btn");
    const navigation = this._document.querySelector(".main-nav");
    const header = this._document.querySelector(".main-header");
    const headerControls = this._document.querySelector(".header-controls");
    menuBtn.addEventListener("click", () => {
        mainWrap.classList.toggle("no-scroll");
        menuBtn.classList.toggle("active");
        navigation.classList.toggle("active");
        header.classList.toggle("menu-open");
        if (window.innerWidth > 1199) {
            headerControls.classList.toggle("active");
        }
    });


    $(".menu-item").hover(function () {
        $(this).parent().addClass("hover");
    }, function () {
        $(".menu-item").parent().removeClass("hover");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/main-nav.js